/*
let lastScrollTop = 0; // Variable to store the last scroll position

    document.addEventListener("scroll", function() {
        var header = document.getElementById("masthead");
        var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScrollTop > 100) {
            header.classList.add("sticky");
        } else {
            // If we're within the top 100px, always show the large header
            header.classList.remove("sticky");
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
    }, false);
    */